/***
 * A set has the following structure:
 *
 * interface Set {
 *   nowName: string,
 *   nowLabel: string,
 *   nowDescription: string,
 *   [propertyName: string]: Schema
 * }
 *
 * Set primitives.js for how Schema is defined
 *
 * TODO: Do we need a way to mark which properties in a set are required (must be defined in the properties config)
 * and which are optional? In addition, do we need to if properties must be set as required (non-null)
 * in the schema or not?
 */
import * as primitives from './primitives';

export const record = {
	nowName: 'record',
	nowLabel: 'Record',
	nowDescription: null,
	sysId: primitives.sysId,
	table: primitives.table,
	view: {
		nowLabel: 'View',
		type: 'string'
	}
};

export const list = {
	nowName: 'list',
	nowLabel: 'List',
	nowDescription: null,
	table: primitives.table,
	query: primitives.query,
	page: {
		nowLabel: 'Page number',
		nowDescription: null,
		type: 'integer'
	},
	recordsPerPage: {
		nowLabel: 'Records per Page',
		nowDescription: null,
		type: 'integer'
	}
};
